import React, { Component, Fragment } from 'react';
import FormMultiSelect, { SearchableSelect } from '../_shared/forms/FormMultiSelect';
import FormInputText from '../_shared/forms/FormInputText';
import FormInputNumber from '../_shared/forms/FormInputNumber';
import FormCheckbox from '../_shared/forms/FormCheckbox';
import FormSelect from '../_shared/forms/FormSelect';
import DatePicker from 'react-datepicker';
import JobExtras from './JobExtras';
import Dropzone from 'react-dropzone';
import SubmitButton from '../_shared/SubmitButton';
import FormError from '../_shared/forms/FormError';

// Matches Carbon's day-of-week values (Monday = 1 ... Friday = 5)
const RECURRING_DAYS = [
    { value: 1, label: 'Mon' },
    { value: 2, label: 'Tue' },
    { value: 3, label: 'Wed' },
    { value: 4, label: 'Thu' },
    { value: 5, label: 'Fri' },
];

class AdminCreateJob extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let submitButtonText = this.props.buttonText === 'Edit' ? 'Edit Job' : 'Create Job';
        let { errors, data } = this.props;
        const isManagerOrAbove = ['manager', 'admin', 'superadmin'].includes(this.props.currentUser?.role?.name);
        const dateReadyDisabled = this.props.buttonText === 'Edit' && !isManagerOrAbove;
        const selectedJob = this.props.jobs?.find((job) => job.id === Number(data.job_type_id));

        return (
            <form onSubmit={this.props.onSubmit} encType="multipart/form-data" className="transform-text">
                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Customer Details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            classes={errors.customer_id ? 'is-invalid' : ''}
                            name="customer_id"
                            options={this.props.customers}
                            value={data.customer_id}
                            handleChange={this.props.handleSearchableSelectChange}
                            label="customer"
                            error={errors.customer_id}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            classes={errors.customer_contact_id ? 'is-invalid' : ''}
                            name="customer_contact_id"
                            options={data.contacts}
                            value={data.customer_contact_id}
                            handleChange={this.props.handleSearchableSelectChange}
                            label="contact"
                            error={errors.customer_contact_id}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            classes=""
                            name="job_source_id"
                            options={this.props.jobSources}
                            value={data.job_source_id}
                            handleChange={this.props.handleSearchableSelectChange}
                            label="job source"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            myRef={this.props.myRef}
                            label="Purchase Order Number"
                            name="purchase_order_number"
                            type="text"
                            classes={errors.purchase_order_number ? 'form-control is-invalid' : 'form-control'}
                            value={data.purchase_order_number}
                            handleChange={this.props.handleChange}
                            error={errors.purchase_order_number}
                            disabled={this.props.disablePo}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <FormInputText
                            label="Purchase Order Total"
                            name="purchase_order_total"
                            type="text"
                            classes="form-control"
                            value={data.purchase_order_total}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                    {data.job_id ? (
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="SLA"
                                name="sla"
                                step="1"
                                min="1"
                                classes="form-control"
                                value={data.sla}
                                handleChange={this.props.handleChange}
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>

                <div className="row">
                    <div className="form-group col-md-4">
                        <FormInputText
                            label="department"
                            name="department"
                            type="text"
                            classes="form-control"
                            value={data.department}
                            disabled
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <SearchableSelect
                            name="service_provider_id"
                            options={this.props.providers}
                            value={data.service_provider_id}
                            handleChange={this.props.handleSearchableSelectChange}
                            label="Provider"
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <div className="form-group">
                            <label>Planned date</label>
                            <DatePicker
                                name="execution_date"
                                className="form-control"
                                placeholderText="Planned date..."
                                minDate={new Date()}
                                onChange={(date) => this.props.handleDateChange(date, 'execution_date')}
                                selected={data.execution_date}
                                dateFormat="dd/MM/yyyy"
                                isClearable
                            />
                        </div>
                    </div>
                </div>

                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Address Details</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="Address Line 1"
                            name="address_line_1"
                            type="text"
                            classes={errors.address_line_1 ? 'form-control is-invalid' : 'form-control'}
                            value={data.address_line_1}
                            handleChange={this.props.handleChange}
                            error={errors.address_line_1}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Address Line 2"
                            name="address_line_2"
                            type="text"
                            classes={errors.address_line_2 ? 'form-control is-invalid' : 'form-control'}
                            value={data.address_line_2}
                            handleChange={this.props.handleChange}
                            error={errors.address_line_2}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Postcode"
                            name="postcode"
                            type="text"
                            classes={errors.postcode ? 'form-control is-invalid' : 'form-control'}
                            value={data.postcode}
                            handleChange={this.props.handleChange}
                            error={errors.postcode}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="City"
                            name="city"
                            type="text"
                            classes={errors.city ? 'form-control is-invalid' : 'form-control'}
                            value={data.city}
                            handleChange={this.props.handleChange}
                            error={errors.city}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Telephone"
                            name="telephone"
                            type="text"
                            classes={errors.telephone ? 'form-control is-invalid' : 'form-control'}
                            value={data.telephone}
                            handleChange={this.props.handleChange}
                            error={errors.telephone}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="On-Site Contact Name"
                            name="os_contact_name"
                            type="text"
                            classes={errors.os_contact_name ? 'form-control is-invalid' : 'form-control'}
                            value={data.os_contact_name}
                            handleChange={this.props.handleChange}
                            error={errors.os_contact_name}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="On-Site Contact Mobile"
                            name="os_contact_mobile"
                            type="text"
                            classes={errors.os_contact_mobile ? 'form-control is-invalid' : 'form-control'}
                            value={data.os_contact_mobile}
                            handleChange={this.props.handleChange}
                            error={errors.os_contact_mobile}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <FormCheckbox
                            name="os_contact_updates"
                            label="On-Site Contact Job Updates"
                            checked={data.os_contact_updates}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Details</h6>
                    </div>
                </div>
                 <div className="row">
                    <div className="col-12">
                        <label htmlFor="description">Special Requests</label>
                        <textarea
                            className="form-control"
                            name="special_requests"
                            id="special_requests"
                            value={data.special_requests}
                            onChange={this.props.handleChange}
                            placeholder="Please add any details that will assist our co-ordinators in their planning e.g call tenant before attending or needle sweep required"
                            rows="5"
                        ></textarea>
                    </div>
                </div>                <div className="row">
                    <div className="col-12">
                        <label htmlFor="admin_notes">Admin notes</label>
                        <textarea
                            className="form-control"
                            name="admin_notes"
                            id="admin_notes"
                            value={data.admin_notes}
                            onChange={this.props.handleChange}
                            placeholder="Admin notes..."
                            rows="5"
                        ></textarea>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <label htmlFor="description">Description</label>
                        <textarea
                            className="form-control"
                            name="description"
                            id="description"
                            value={data.description}
                            onChange={this.props.handleChange}
                            placeholder="Description..."
                            rows="5"
                        ></textarea>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <FormSelect
                            classes={errors.job_type_id ? 'form-control is-invalid' : 'form-control'}
                            name="job_type_id"
                            options={this.props.jobs}
                            value={data.job_type_id}
                            handleChange={this.props.handleChange}
                            label="job type"
                            error={errors.job_type_id}
                        />
                    </div>
                        <div className="form-group col-md-4 hidden">
                            <FormInputNumber
                                type="number"
                                label="Customer quantity"
                                name="quantity"
                                step="1"
                                min="1"
                                classes={errors.quantity ? 'form-control is-invalid' : 'form-control'}
                                value={data.quantity}
                                handleChange={this.props.handleChange}
                                error={errors.quantity}
                            />
                        </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                        <label>Date ready</label>
                        <DatePicker
                            className={errors.date_ready ? 'is-invalid form-control' : 'form-control'}
                            placeholderText="Date ready..."
                            minDate={moment().subtract(1, 'year').toDate()}
                            onChange={(date) => this.props.handleDateChange(date, 'date_ready')}
                            selected={data.date_ready}
                            dateFormat="dd/MM/yyyy"
                            // filterDate={date => this.props.isWeekday(date)}
                            isClearable={!dateReadyDisabled}
                            disabled={dateReadyDisabled}
                        />
                        {errors.date_ready ? <FormError error={errors.date_ready} /> : ''}
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4" style={{ paddingRight: '8px' }}>
                        <FormMultiSelect
                            label="Job Extras"
                            options={this.props.extrasOptions}
                            handleMultiSelectChange={(value) =>
                                this.props.handleMultiSelectChange(value, 'selectedExtras')
                            }
                            classes={'form-control'}
                            prefixes={data.selectedExtras}
                        />
                    </div>

                    {data.showGardeningExtras ? (
                        <div className="form-group col-md-4" style={{ paddingRight: '8px' }}>
                            <FormMultiSelect
                                label="Gardening Extras"
                                options={this.props.gardeningExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.props.handleMultiSelectChange(value, 'selectedGardeningExtras')
                                }
                                classes="form-control"
                                prefixes={data.selectedGardeningExtras}
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.showWasteBagExtras ? (
                        <div className="form-group col-md-4" style={{ paddingRight: '8px' }}>
                            <FormMultiSelect
                                label="Waste bag extras"
                                options={this.props.wasteBagExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.props.handleMultiSelectChange(value, 'selectedWasteBagExtras')
                                }
                                classes="form-control"
                                prefixes={data.selectedWasteBagExtras}
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.showSkipHireExtras ? (
                        <div className="form-group col-md-4">
                            <FormMultiSelect
                                label="Skip hire extras"
                                options={this.props.skipHireExtrasOptions}
                                handleMultiSelectChange={(value) =>
                                    this.props.handleMultiSelectChange(value, 'selectedSkipHireExtras')
                                }
                                class="form-control"
                                prefixes={data.selectedSkipHireExtras}
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.price_quoted ? (
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Custom price without vat"
                                name="custom_price"
                                step="0.01"
                                min="0"
                                classes={errors.custom_price ? 'form-control is-invalid' : 'form-control'}
                                value={data.custom_price}
                                handleChange={this.props.handleJobPrice}
                                error={errors.custom_price}
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.price_quoted ? (
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Custom price with vat"
                                name="custom_price_with_vat"
                                step="0.01"
                                min="0"
                                classes="form-control"
                                value={data.custom_price_with_vat}
                                handleChange={this.props.handleJobPrice}
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.provider_price_quoted ? (
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider custom price without vat"
                                name="provider_custom_price"
                                classes={errors.provider_custom_price ? 'form-control is-invalid' : 'form-control'}
                                value={data.provider_custom_price}
                                handleChange={this.props.handleProviderJobPrice}
                                error={errors.provider_custom_price}
                                step="0.01"
                                min="0"
                            />
                        </div>
                    ) : (
                        ''
                    )}

                    {data.provider_price_quoted ? (
                        <div className="form-group col-md-4">
                            <FormInputNumber
                                type="number"
                                label="Provider custom price with vat"
                                name="provider_custom_price_with_vat"
                                value={(data.provider_custom_price_with_vat).toFixed(2)}
                                handleChange={this.props.handleProviderJobPrice}
                                classes={'form-control'}
                                step="0.01"
                                min="0"
                            />
                        </div>
                    ) : (
                        ''
                    )}
                </div>

                {data.recurring ? (
                    <div className="row">
                        <div className="form-group col-12">
                            {data.recurring_interval ? (
                                // Legacy recurring jobs keep their existing numeric interval when edited.
                                <FormInputNumber
                                    type="number"
                                    label="Recurring interval"
                                    name="recurring_interval"
                                    step="1"
                                    min="1"
                                    classes={errors.recurring_interval ? 'form-control is-invalid' : 'form-control'}
                                    value={data.recurring_interval}
                                    handleChange={this.props.handleChange}
                                    error={errors.recurring_interval}
                                />
                            ) : (
                                <Fragment>
                                    <label>Recurring days</label>
                                    {data.recurring_days.length > 1 && (
                                        <p className="text-muted mb-1">
                                            <small>
                                                The job cycles through these weeks in order, then repeats. Leave a
                                                week's days unticked to skip it - e.g. for a fortnightly collection,
                                                tick a day in Week 1 and leave Week 2 blank.
                                            </small>
                                        </p>
                                    )}
                                    {data.recurring_days.map((week_days, weekIndex) => (
                                        <div key={weekIndex} className="d-flex align-items-center mb-1">
                                            {data.recurring_days.length > 1 && (
                                                <span className="mr-2">Week {weekIndex + 1}:</span>
                                            )}
                                            {RECURRING_DAYS.map((day) => (
                                                <FormCheckbox
                                                    key={day.value}
                                                    name={`recurring_week_${weekIndex}_day_${day.value}`}
                                                    label={day.label}
                                                    checked={week_days.includes(day.value)}
                                                    handleChange={() =>
                                                        this.props.handleRecurringDayToggle(weekIndex, day.value)
                                                    }
                                                />
                                            ))}
                                            {data.recurring_days.length > 1 && week_days.length === 0 && (
                                                <span className="text-muted ml-2">
                                                    <small>no collection this week</small>
                                                </span>
                                            )}
                                            {data.recurring_days.length > 1 && (
                                                <a
                                                    href="#"
                                                    className="ml-2"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.props.removeRecurringWeek(weekIndex);
                                                    }}
                                                >
                                                    remove <i className="fas fa-times"> </i>
                                                </a>
                                            )}
                                        </div>
                                    ))}
                                    {data.recurring_days.length < 2 && (
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.props.addRecurringWeek();
                                            }}
                                        >
                                            + Add alternating week
                                        </a>
                                    )}
                                    {errors.recurring_days ? <FormError error={errors.recurring_days} /> : ''}
                                </Fragment>
                            )}
                        </div>
                    </div>
                ) : (
                    ''
                )}

                {data.manager_review ? (
                    <div className="row">
                        <div className="col-12">
                            <FormInputText
                                label="Manager Review Reason"
                                name="manager_review_reason"
                                type="text"
                                classes={errors.manager_review_reason ? 'form-control is-invalid' : 'form-control'}
                                value={data.manager_review_reason}
                                handleChange={this.props.handleChange}
                                error={errors.manager_review_reason}
                            />
                        </div>
                    </div>
                ) : (
                    ''
                )}

                {data.excluded_from_sla ? (
                    <div className="row">
                        <div className="col-12">
                            <FormInputText
                                label="Reason for Excluding from SLA"
                                name="excluded_from_sla_reason"
                                type="text"
                                classes={errors.excluded_from_sla_reason ? 'form-control is-invalid' : 'form-control'}
                                value={data.excluded_from_sla_reason}
                                handleChange={this.props.handleChange}
                                error={errors.excluded_from_sla_reason}
                            />
                        </div>
                    </div>
                ) : (
                    ''
                )}

                <div className="row">
                    <div className="col-12">
                        <FormCheckbox
                            name="non_stop"
                            label="24H"
                            checked={data.non_stop}
                            handleChange={this.props.handleChange}
                        />
                        <FormCheckbox
                            name="two_person_team"
                            label="TWO PERSON TEAM"
                            checked={data.two_person_team}
                            handleChange={this.props.handleChange}
                        />
                        <FormCheckbox
                            name="price_quoted"
                            label="QUOTED PRICE"
                            checked={data.price_quoted}
                            handleChange={this.props.handleChange}
                        />

                        {!data.waste_container_identifier && (
                            <FormCheckbox
                                name="recurring"
                                label="RECURRING JOB"
                                checked={data.recurring}
                                handleChange={this.props.handleChange}
                            />
                        )}

                        <FormCheckbox
                            name="manager_review"
                            label="MANAGER REVIEW"
                            checked={data.manager_review}
                            handleChange={this.props.handleChange}
                        />

                        <FormCheckbox
                            name="excluded_from_sla"
                            label="EXCLUDE FROM SLA"
                            checked={data.excluded_from_sla}
                            handleChange={this.props.handleChange}
                        />

                        <FormCheckbox
                            name="provider_price_quoted"
                            label="PROVIDER QUOTED PRICE"
                            checked={data.provider_price_quoted}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>

                <JobExtras
                    type="Job extra"
                    extras={data.selectedExtras}
                    onExtraQtyChange={this.props.onExtraQtyChange}
                    onExtraWeightChange={this.props.onExtraWeightChange}
                    extrasType={'selectedExtras'}
                    dtn={false}
                    isAdmin={true}
                />
                <JobExtras
                    type="Gardening extra"
                    extras={data.selectedGardeningExtras}
                    onExtraQtyChange={this.props.onExtraQtyChange}
                    extrasType={'selectedGardeningExtras'}
                    dtn={false}
                    isAdmin={true}
                />

                <JobExtras
                    type="Waste bag extra"
                    extras={data.selectedWasteBagExtras}
                    onExtraQtyChange={this.props.onExtraQtyChange}
                    extrasType={'selectedWasteBagExtras'}
                    dtn={false}
                    isAdmin={true}
                />

                <JobExtras
                    type="Skip hire extra"
                    extras={data.selectedSkipHireExtras}
                    onExtraQtyChange={this.props.onExtraQtyChange}
                    extrasType="selectedSkipHireExtras"
                    dtn={false}
                    isAdmin={true}
                />

                <div className="row pb-3">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 cw-bg-grey text-white">Photos/Videos</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Dropzone
                            onDrop={(acceptedFiles) => this.props.onDrop(acceptedFiles)}
                            onDropRejected={(rejectedFiles) => this.props.onDropReject(rejectedFiles, this.props.name)}
                            maxSize={55000000}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <section>
                                    <div
                                        {...getRootProps()}
                                        className="d-flex flex-column align-items-center jobs-dropzone"
                                    >
                                        <input {...getInputProps()} />
                                        {data.acceptedFiles.length > 0 ? (
                                            <div className="row w-100">
                                                {data.acceptedFiles.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        className="col-md-2 d-flex flex-column justify-content-between"
                                                    >
                                                        {file.type.match('video.*') ? (
                                                            <video
                                                                id="video-element"
                                                                style={{
                                                                    height: '100px',
                                                                }}
                                                                controls
                                                            >
                                                                <source
                                                                    style={{
                                                                        height: '100px',
                                                                    }}
                                                                    src={window.URL.createObjectURL(file)}
                                                                    type={file.type}
                                                                />
                                                            </video>
                                                        ) : (
                                                            <img
                                                                src={window.URL.createObjectURL(file)}
                                                                className="img-fluid"
                                                            />
                                                        )}
                                                        <div
                                                            className="text-center dropzone-remove-link"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                this.props.removeFile(file, index);
                                                            }}
                                                        >
                                                            remove <i className="fas fa-times"> </i>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="py-5 text-muted mb-0 jobs-dropzone-placeholder">
                                                Drag and drop, or click to select images and videos related to this job
                                            </p>
                                        )}
                                    </div>
                                    <div></div>
                                </section>
                            )}
                        </Dropzone>
                        {this.props.rejectedFiles && this.props.rejectedFiles[this.props.name] ? (
                            <p className="text-danger mt-2">Photo size must be less than 5mb</p>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-4">
                       <FormInputText
                            label="Job Created By"
                            name="created_by"
                            type="text"
                            classes={errors.created_by ? 'form-control is-invalid' : 'form-control'}
                            value={this.props.createdBy ?? ''}
                            handleChange={this.props.handleChange}
                        />
                    </div>
                </div>
                <SubmitButton
                    buttonText={submitButtonText}
                    loading={data.loading}
                    style={{ width: 200, marginTop: 50 }}
                />
                {data.job_id ? (
                    <button
                        type="button"
                        className="btn btn-cw-green"
                        style={{ width: 200, marginTop: 50, marginLeft: 15 }}
                        disabled={data.loading || this.props.recreatingJob}
                        onClick={() => this.props.onRecreateJob(data.job_id)}
                    >
                        {this.props.recreatingJob ? 'Recreating...' : 'Recreate Job'}
                    </button>
                ) : null}                    
            </form>
        );
    }
}

export default AdminCreateJob;
